import { forwardRef, memo } from 'react';
import cx from 'classnames';
import { useTruncationTooltip } from '../../../hooks/useTruncationTooltip';
import '../List.css';
import cn from '../List.css.json';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListHeader = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function ListHeader(props, ref) {
  const textRef = useTruncationTooltip();
  return /*#__PURE__*/_jsx("li", {
    id: props.id,
    role: "presentation",
    className: cx(props.className, cn.heading),
    ref: ref,
    "data-testid": props.testId,
    style: props.style,
    onClick: event => {
      // timeout to delay until closing, if any, to dispatch the event
      setTimeout(() => {
        props.onHeaderSelected?.({
          groupIndex: props.groupIndex
        });
      }, 0);
      event.preventDefault();
    },
    children: /*#__PURE__*/_jsx("span", {
      ref: textRef,
      children: props.text
    })
  });
}));
//# sourceMappingURL=ListHeader.js.map